import { Attributes } from '@splitsoftware/splitio/types/splitio';
import { useTreatments } from '@splitsoftware/splitio-react';
import Cookies from 'universal-cookie';
import { SplitIO } from 'types';
import useSplit from 'hooks/useSplit';

const cookies = new Cookies();

const getSplitAttributes = (): Attributes => ({
  isVip: !!cookies.get(SplitIO.Cookie.SPLIT_IS_VIP),
});

interface Result {
  isReady: boolean;
  split: boolean;
}

const useSplitTreatment = (split: SplitIO.Split, treatment: SplitIO.Treatment): Result => {
  const { isReady } = useSplit();
  const treatments = useTreatments([split], getSplitAttributes());

  if (isReady && treatments[split].treatment === treatment) {
    return { isReady, split: true };
  }

  return { isReady, split: false };
};

export default useSplitTreatment;
